import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Avatar } from 'shared-components/image/avatar';
import AttendeeListCompact from './attendee-list-compact';
import classnames from 'classnames';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import SharedIntlProviderHOC from '../shared-components/hocs/sharedIntlProviderHOC';

class AttendeeRsvp extends Component {
  render () {
    const {
      attendees,
      className,
      guestAvatar,
      guestFirstName,
      handleAcceptInvitation,
      handleDeclineInvitation,
      isLoggedIn,
      redirectLocation,
      scrollToAttendeeSection,
      hasUserRSVP
    } = this.props;
    const prefix = SharedIntlProviderHOC.getUrlPrefix();
    const urlPrefix = prefix ? `/${prefix}` : '';

    return (
      <div className={classnames('AttendeeRsvp','flex column', className)}>
        <div className="flex margin-lg-bottom">
          <Avatar src={guestAvatar} className="guest-avatar-img avatar-img" />
          <h2 className="invite-header" data-testing-id="title">
            <FormattedMessage
              id='invite.attendee_rsvp.join_to_event'
              defaultMessage='Join {name}’s Event'
              values={{
                name: guestFirstName
              }}
            />
          </h2>
        </div>
        <p className="invite-text" data-testing-id="info">
          <FormattedMessage
            id='invite.attendee_rsvp.you_invited'
            defaultMessage='{name} invited you to their event. Check out the details below and let them know if you can make it.'
            values={{
              name: guestFirstName
            }}
          />
        </p>
        <div className="margin-lg-bottom">
          <button className="btn btn-primary margin-lg-right" onClick={handleAcceptInvitation} data-testing-id="accept-invitation-btn">
            <FormattedMessage id='invite.attendee_rsvp.accept_invitation' defaultMessage='Accept Invitation' />
          </button>

          <button className="btn btn-outlined-light" onClick={handleDeclineInvitation} data-testing-id="decline-invitation-btn">
            <FormattedMessage id='invite.attendee_rsvp.decline_invitation' defaultMessage='Decline' />
          </button>
        </div>

        <AttendeeListCompact
          attendees={attendees}
          onClick={scrollToAttendeeSection}
          showRsvpText
          isLoggedIn={isLoggedIn}
          urlPrefix={urlPrefix}
          redirectLocation={redirectLocation}
        />

      </div>
    );
  }
}

AttendeeRsvp.propTypes = {
  attendees: PropTypes.object,
  className: PropTypes.string,
  guestAvatar: PropTypes.string,
  guestFirstName: PropTypes.string,
  handleAcceptInvitation: PropTypes.func,
  handleDeclineInvitation: PropTypes.func,
  isLoggedIn: PropTypes.bool,
  redirectLocation: PropTypes.string
};

export default AttendeeRsvp;
